import { TimeFormatType } from './time-format-key'
import type { IResolvedTimeFormat } from './i-resolved-time-format'

function detectBrowserTimeFormat(): IResolvedTimeFormat {
  try {
    const options = new Intl.DateTimeFormat(undefined, { hour: 'numeric' }).resolvedOptions()

    if (options.hourCycle === 'h11' || options.hourCycle === 'h12') {
      return TimeFormatType.H12
    }

    if (options.hourCycle === 'h23' || options.hourCycle === 'h24') {
      return TimeFormatType.H24
    }

    return options.hour12 ? TimeFormatType.H12 : TimeFormatType.H24
  } catch {
    return TimeFormatType.H24
  }
}

export function resolveTimeFormat(value: TimeFormatType | null): IResolvedTimeFormat {
  return value === null ? detectBrowserTimeFormat() : value
}
